export default {
  getHonourHome: '/honour/client/home', // 荣耀骑士首页
  askForLeave: '/honour/client/askForLeave', // 请假
  honourJoin: '/honour/client/join', // 申请加入荣耀骑士
  honourQuit: '/honour/client/quit', // 退出荣耀骑士
  getPropTips: '/honour/client/getPropTips' // 荣耀骑士首页获取道具提醒
}
